import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectDiscountPromoSearchTypeFilter } from 'shared/selectors/advancedFilters';
import { selectPromoSearchTypes as selectAllPromoSearchTypes } from 'shared/selectors/jsonQuery';
import { selectPromoSearchTypes } from 'shared/selectors/promoSearchTypes';
import { getPromoSearchFilterValuesByType } from 'shared/utils/promoSearchTypes';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useDiscountPromoInfo } from './hooks/useDiscountPromoInfo';
import { SliderModal } from '@cian/frontend-newbuilding-promo-modal-widget';
import { trackNextInfoSlideShow, trackInfoArticleClick } from './tracking';
import { AdvancedFilterRowLabelInfo } from 'shared/components/AdvancedFilter/components/AdvancedFilterRowLabelInfo';

export const DiscountPromoSearchTypeContainer: FC = () => {
  const { label, value, options } = useSelector(selectDiscountPromoSearchTypeFilter);
  const allValues = useSelector(selectAllPromoSearchTypes);
  const promoSearchTypes = useSelector(selectPromoSearchTypes);

  const onChange = useFilterChangeCallback();

  const { isInfoModalVisible, infoSlides, openInfoModal, closeInfoModal } = useDiscountPromoInfo();

  const handleDiscountPromoSearchTypesChange = useCallback(
    (newValues: NonEmptyArray<string> | null) => {
      onChange({
        action: 'setPromoSearchTypes',
        arguments: [
          {
            allValues,
            newValues,
            availableFilterValues: getPromoSearchFilterValuesByType('discount', promoSearchTypes),
          },
        ],
      });
    },
    [allValues, onChange, promoSearchTypes],
  );

  const info = !!infoSlides && (
    <AdvancedFilterRowLabelInfo testId="discountPromoSearchType|info" onClick={openInfoModal}>
      {isInfoModalVisible && (
        <SliderModal
          slides={infoSlides}
          onClose={closeInfoModal}
          onScrollNext={trackNextInfoSlideShow}
          onArticleClick={trackInfoArticleClick}
        />
      )}
    </AdvancedFilterRowLabelInfo>
  );

  return (
    <AdvancedFilterRow label={label} info={info}>
      <MultiSelectionAdvancedFilter
        value={value}
        options={options}
        onFilterChange={handleDiscountPromoSearchTypesChange}
      />
    </AdvancedFilterRow>
  );
};
